<div id="content" >
  <section class="banner">
    <div class="container">
      <div class="banner-content">
        <h1> Become a Partner</h1>
        <a  (click)="SignupClick()" class="btn">Apply Now  </a>
        <span class="have-ac login"> Already have an account <a class="login-click" [href]="globalurl + 'vendors'" target="_blank">click here </a> to Login </span>
      </div>
    </div>
  </section>
  <section class="our-mission-vision">
    <div class="container">
      <div class="box-wrap">
        <div class="box vision-box">
         
          <p>MyLifeWell is the only comprehensive solution for wellness seekers which provides access to virtual programs, active and wellness travel, and wellness products all on one platform. We are the go-to resource for wellness aficionados as they navigate their journey to a healthy lifestyle.

          </p>
          <p> Our mission is to help improve personal and social well being for clients all over the world, and in order to do that, we need your help. We’re looking to partner with certified wellness experts, wellness resorts and retreats, active and wellness tour operators as well as new and innovate wellness product companies globally to deliver the programs and resources for healthy living.

          </p>
          <p>Now more than ever, there is a tremendous need for physical, social, and emotional well being. If you’ve invested in perfecting your craft,  creating uplifting wellness experiences, designing an environment that promotes wellness or developing products which enhance an individual’s quality of life….if you’re ready to share your gifts with people yearning to be the best versions of themselves, we invite you to  <a   (click)="SignupClick()" class="login-click">apply</a> for partnership. 
          </p>
          <p>Join us in inspiring people to live well!
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="become-a-partner">
    <div class="container clearfix">
      <div class="side1">
        <div class="sec-head hidden-xs">
          <h2> Why Partner With Us</h2>
        </div>
        <div class="reason reason4">
          <div>
            <img src="assets/images/img-01.jpg" alt="" />

          </div>
          <span class="number"> 1 </span>
          <div class="for-you">
            <div class="res-text">
              <h4>Multiple revenue streams (virtual, travel, shop)
              </h4>
              <p>Expand your revenue streams by earning royalty on digital content or by creating multiple touchpoints across digital, travel and shopping platforms.
                
              </p>
            </div>
            <div class="res-img">
              <img src="assets/images/img-02.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="side2">
        <div class="reson1">
          <div class="res-text">
            <h4> Targeted Leads & Bookings 
            </h4>
            <p>Acquire only highly qualified leads through our hyper targeted marketing campaigns
            </p>
          </div>
          <span class="number counting-one"> 
            2
          </span>
        </div>
      </div>
      <div class="side3">
        <div class="reson2">
          <div class="res-text">
            <h4>Insights & Analytics 
            </h4>
            <p>Receive invaluable insights and analytics on customer behavioral and shopping patterns
            </p>
          </div>
          <div class="res-img">
            <img src="assets/images/img-04.jpg" alt="" />
          </div>
          <span class="number"> 3 </span>
        </div>
        <div class="reson3">
          <div class="res-text">
            <h4>We Care
            </h4>
            <p>We believe in building a trustworthy partnership with our vendors that last a lifetime!
            </p>
          </div>
          <div class="res-img">
            <img src="assets/images/img-05.jpg" alt="" />
          </div>

          <span class="number"> 4 </span>
        </div>
      </div>
    </div>
  </section>
  <section class="benifits">
    <div class="container">
      <h2> Enjoy all the benefits</h2>
      <ul class="banifits-list d-flex justify-content-between flex-wrap">
        <li>
          <span><img src="assets/images/ico-4.png" alt="" /> </span>
          <h3>Advanced Dashboard

          </h3>
          <p>
            Manage all your listings,queries and bookings at one glance with an easy to use vendar dashboard panel
          </p>
        </li>
        <li>
          <span><img src="assets/images/ico-1.png" alt="" /> </span>
          <h3>Receive Efficient Support
          </h3>
          <p>
            Get 24x7 fast and reliable customer care service for all your queries
          </p>
        </li>

        <li>
          <span><img src="assets/images/ico-2.png" alt="" /> </span>
          <h3>Streamline Your Business
          </h3>
          <p>
            Streamlined booking, payment and correspondence process
          </p>
        </li>

        <li>
          <span><img src="assets/images/ico-1.png" alt="" /> </span>
          <h3>Boost Social Awareness

          </h3>
          <p>
            Promote your brand by getting featured on our social media channels
          </p>
        </li>
      </ul>
    </div>
  </section>
  <section class="become-partner">
    <div class="container dis-box">
      <div class="ready-for-parner">
        <h2> Are you ready to become a partner ?</h2>
        <p>
          Sign up now and join our mission to inspire more wellness travelers together!
        </p>
      </div>
      <div class="reg-now">
        <a  class="btn" (click)="SignupClick()"> apply now </a>
      </div>
    </div>
  </section>
</div>
